/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы адресов доставки
   */
  app.UserDeliveryAddressFormView = app.View.extend({
    el: '#delivery-address-form',

    model: null,
    suggest: false,

    // Обработчики пользовательских событий
    events: {
      'click #cancel-delivery-address-edit': 'cancel',
      'click #save-delivery-address': 'save',
      'change .js-recipient-input': 'toggleRecipientSubForm'
    },

    // Для сохранения новой модели необходимо при создании передать экземпляр коллекции в options.collection
    run: function (options) {
      if (options && options.suggest) {
        this.suggest = true;
      }
      if (options && options.settlement) {
        this.settlement = options.settlement;
      }
      this.$settlement = this.$('#delivery-address-settlement');
      this.$fields = this.$el.find('.field');
      this.childViews.settlementAutocomplete = new app.SettlementAutocompleteView({
        el: this.$settlement,
        settlement: this.settlement,
        user: this.user,
      });
      var countryFlagModel = app.countryFlag.clone();
      countryFlagModel.unset('id');
      var phoneInputmask = new app.PhoneInputmaskView({el: this.$('.input_phone'), model: countryFlagModel});
      phoneInputmask.render();
      new app.ChoiceCountryView({'el': this.$('.choice-country'), model: countryFlagModel});
      if (this.suggest) {
        app.helpers.DaDataHelper.initDaDataSuggestions(this, {
          streetFieldSelector: '#delivery-address-street',
          houseFieldSelector: '#delivery-address-house_num'
        });
      }
      this.listenTo(this.childViews.settlementAutocomplete, 'autocompleteDone', this.changeSettlement);
      this.listenTo(this.settlement, 'change:settlement_id', function () {
        this.$('#delivery-address-street').val('');
        this.$('#delivery-address-house_num').val('');
        this.$('#delivery-address-postal_code').val('');
        this.$('#delivery-address-kladr_id').val('');
        this.$('#delivery-address-fias_id').val('');
        this.$('#delivery-address-kladr_full_address').val('');
      });
    },

    changeSettlement: function (settlementId) {
      if (settlementId) {
        this.settlement.save({settlement_id: settlementId});
      }
    },

    render: function () {
      var that = this,
        value,
        code = app.countryFlag.get('code') || '+7',
        isRecipient = false,
        recipientCheckbox = this.$('#is-another-recipient');

      if (this.model) {
        this.$fields.each(function () {
          value = that.model.get(this.name);
          if ($(this).is('select')) {
            $(this).find('option[value=' + value + ']').attr('selected', 'selected');
          } else if (this.name === 'settlement') {
            if (value.name && value.region) {
              $(this).val(value.name + ' (' + value.region + ')');
              $(this).data('settlement-id', value.id);
            } else if (value.name) {
              $(this).val(value.name);
              $(this).data('settlement-id', value.id);
            }
            that.settlement.save({settlement_id: value.id});
          } else {
            $(this).val(value);
          }
          if (this.name === 'recipient_name' && $(this).val()) {
            isRecipient = true;
          }
        });
        if ((isRecipient && !recipientCheckbox.prop('checked')) || (!isRecipient && recipientCheckbox.prop('checked'))) {
          recipientCheckbox.click();
        }
      } else {
        this.$fields.each(function () {
          if ($(this).is('select')) {
            $(this).find('option[value=1]').attr('selected', 'selected');
          } else if (this.name === 'phone') {
            $(this).val(code);
          } else if (this.name !== 'settlement') {
            $(this).val('');
          }
        });
      }

      this.clearErrors();

      this.toggle();
    },
    selectSuggestion: function (suggestion) {
      this.$('#delivery-address-postal_code').val(suggestion.data.postal_code);
      this.$('#delivery-address-kladr_id').val(suggestion.data.kladr_id);
      this.$('#delivery-address-fias_id').val(suggestion.data.fias_id);
      this.$('#delivery-address-kladr_full_address').val(suggestion.unrestricted_value);
    },

    /**
     * Показывает или скрывает вложенную форму "Заказ за меня будет получать другое лицо"
     * @param {Event} e Событие изменения чекбокса "Заказ за меня будет получать другое лицо"
     */
    toggleRecipientSubForm: function (e) {
      var target = this.$(e.currentTarget);
      if (target.prop('checked')) {
        this.$('.js-recipient').removeClass('not_display');
        return;
      }
      if (target.prop('checked', false)) {
        this.$('.js-recipient .field').val('');
      }
      this.$('.js-recipient').addClass('not_display');
    },

    /**
     * Отмена заполнения формы
     */
    cancel: function () {
      this.success('cancel');
    },

    /**
     * Сохранение модели
     */
    save: function () {
      var attributes = {};

      this.$fields.each(function () {
        if (this.name === 'settlement') {
          attributes.settlement_id = $(this).data('settlement-id');
        } else {
          attributes[this.name] = $(this).val();
        }
      });

      if (!this.$('#is-another-recipient').prop('checked')) {
        attributes.recipient_name = '';
        attributes.phone = '';
      }

      if (this.model) {
        this.model.save(attributes, {
          'success': this.success.bind(this, 'update'),
          'error': this.error.bind(this)
        });
      } else {
        this.model = this.collection.create(attributes, {
          'success': this.success.bind(this, 'add'),
          'error': this.collectionError.bind(this),
          'wait': true
        });
      }
    },

    /**
     * Тип успешного сохранения: добавление или обновление
     * @param {string} successType
     */
    success: function (successType) {
      this.toggle();

      this.trigger(successType + '-user-delivery-address-form', this.model);
    },

    /**
     * Ошибка при сохранении модели с помощью коллекции
     * @param model Модель
     * @param response Ответ сервера
     * @param options Опции
     */
    collectionError: function (model, response, options) {
      this.model = null;

      this.error(model, response, options);
    },

    /**
     * Ошибка при сохранении модели
     * @param model Модель
     * @param response Ответ сервера
     */
    error: function (model, response) {
      var that = this,
        errors = JSON.parse(response.responseText);

      this.clearErrors();

      errors.forEach(function (error) {
        $('#delivery-address-' + error.field + '-error').text(error.message);
        if (error.field === 'settlement_id') {
          that.$settlement.addClass('error');
        } else {
          $('#delivery-address-' + error.field).addClass('error');
        }
      });
    },

    /**
     * Удаление сообщений об ошибках
     */
    clearErrors: function () {
      this.$fields.each(function () {
        $(this).removeClass('error');
      });
      this.$el.find('.error-message').text('');
    },
  });
})(jQuery);

}.call(window));